import { useEffect, useState } from "react";
import { MapPin } from "lucide-react";
import { api, inr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const OTHER = "__other";
const SAME = "__same";

/** Pickup + drop choosers. value = {pickup_location_id, drop_location_id, pickup_text}. */
export default function LocationPicker({ value, onChange }) {
  const [locs, setLocs] = useState([]);
  useEffect(() => { api.get("/locations").then((r) => setLocs(r.data)); }, []);
  const pickups = locs.filter((l) => l.kind !== "drop");
  const drops = locs.filter((l) => l.kind !== "pickup");
  const fee = (n, l) => (n ? ` · +${inr(n)}${l.charge_basis === "jeep" ? "/jeep" : ""}` : "");
  const label = (l) => `${l.name}${l.area ? ` · ${l.area}` : ""} · pickup ${l.pickup_offset_min} min before${fee(l.pickup_charge, l)}`;
  const pickVal = value.pickup_location_id || (value.other ? OTHER : "");
  const dropVal = value.drop_location_id || SAME;

  return (
    <div className="grid md:grid-cols-2 gap-5 md:col-span-2" data-testid="location-picker">
      <div>
        <label className="jt-eyebrow mb-2 block flex items-center gap-1"><MapPin size={12}/>Pickup point</label>
        <Select value={pickVal} onValueChange={(v) => onChange(v === OTHER ? { ...value, pickup_location_id: "", other: true } : { ...value, pickup_location_id: v, other: false })}>
          <SelectTrigger data-testid="checkout-pickup-select"><SelectValue placeholder="Choose pickup point"/></SelectTrigger>
          <SelectContent>
            {pickups.map((l) => <SelectItem key={l.id} value={l.id} data-testid={`pickup-opt-${l.id}`}>{label(l)}</SelectItem>)}
            <SelectItem value={OTHER} data-testid="pickup-opt-other">Other — my hotel / address</SelectItem>
          </SelectContent>
        </Select>
        {value.other && (
          <Input className="mt-2" placeholder="Hotel name or address" value={value.pickup_text || ""} onChange={(e) => onChange({ ...value, pickup_text: e.target.value })} data-testid="checkout-pickup"/>
        )}
      </div>
      <div>
        <label className="jt-eyebrow mb-2 block flex items-center gap-1"><MapPin size={12}/>Drop point</label>
        <Select value={dropVal} onValueChange={(v) => onChange({ ...value, drop_location_id: v === SAME ? "" : v })}>
          <SelectTrigger data-testid="checkout-drop-select"><SelectValue/></SelectTrigger>
          <SelectContent>
            <SelectItem value={SAME}>Same as pickup</SelectItem>
            {drops.map((l) => <SelectItem key={l.id} value={l.id} data-testid={`drop-opt-${l.id}`}>{l.name}{fee(l.drop_charge, l)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
